<template lang="pug">
    .communication-tabs(v-if="enabled")
        tabs(v-if="tabs.length" :items="tabs" :active-tab="activeTab" @click="activateTab")
            //- Forwarded so a page can put its save buttons in the tab bar, the
            //- way every other form in the admin does.
            template(slot="tabbar-buttons")
                slot(name="tabbar-buttons")
        slot
    .full-height-error(v-else)
        Error(:message="null" :code="403")
</template>

<i18n>
{
    "de": {
        "Conversations": "Konversationen",
        "Form entries": "Formulareinträge"
    }
}
</i18n>

<script>
import { useSetupStore } from '@/stores'
import Tabs from '@/components/Tabs'
import Error from '@/components/Error'
import { messageHubTabs, activeMessageHubTab } from '@/extensions/communication/messageHubTabs'

export default {
    name: 'CommunicationTabs',
    components: {
        Tabs,
        Error
    },
    computed: {
        tabs() {
            return messageHubTabs(this)
        },
        activeTab() {
            return activeMessageHubTab(this.$route.path)
        },
        // Every hub surface renders through this partial, so the gate has to
        // admit all of them — a tenant with only Tickets would otherwise get the
        // 403 page on its own ticket list.
        enabled() {
            return this.enabledExtensions.includes('communication')
                || this.enabledExtensions.includes('forms')
                || this.enabledExtensions.includes('tickets')
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions
        },
        setupStore() {
            return useSetupStore()
        }
    },
    methods: {
        activateTab(item) {
            return this.setupStore.activateTab(item)
        }
    }
}
</script>
